import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { isLogin } from "@/utils/user";
import React, { useContext } from "react";

export default function LoginBtn() {
  const { authInfo, appRuntimeEnv, focusSDK, onGlobalError } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  if (authInfo) return null;
  const doLogin = () => {
    console.log("clickDoLogin");
    // if (!isLogin(appRuntimeEnv) || !authInfo) {
    focusSDK.emit("showLogin");
    //   return;
    // }
  };
  return (
    <div className="login-btn-space no-draggable">
      <div className="loginBtn" onClick={doLogin} />
    </div>
  );
}
